import { useRef, useState } from "react";
import { AutoComplete, AutoCompleteCompleteEvent } from "primereact/autocomplete";
import { useNavigate } from "react-router-dom";
import { searchApi } from "../../services/search/searchApi";
import { Button } from "primereact/button";

export default function GlobalAutocomplete({ ...props }: { [key: string]: any }) {
  const [selectedEntity, setSelectedEntity] = useState(null);
  const [filteredEntities, setFilteredEntities] = useState<any[]>([]);
  const navigate = useNavigate();
  const [triggerEntitiesQuery] = searchApi.useLazySearchQuery();
  const ac = useRef<AutoComplete>(null);

  const groupedItemTemplate = (item: any) => {
    return (
      <div className="flex align-items-center">
        <div className="mr-2">
          <div>{item.title}</div>
          <small>{item.description}</small>
        </div>
      </div>
    );
  };

  const optionGroupTemplate = (option: any) => {
    return (
      <div className="flex align-items-center text-primary border-bottom-1 py-2">
        <div>{option.label}</div>
      </div>
    );
  };

  const search = async (event: AutoCompleteCompleteEvent) => {
    const { data } = await triggerEntitiesQuery({ query: event.query }).unwrap();

    if (data) {
      const _filteredEntities = Object.entries(data).map(([key, value]) => ({
        label: key,
        items: value,
      }));
      setFilteredEntities(_filteredEntities);
    }
  };

  const onSelect = (e: any) => {
    const { id, type } = e.value;
    navigate(`/${type}/${id}`);
  };

  const onClear = () => {
    setSelectedEntity(null);
    ac.current?.focus();
  };

  return (
    <div className="card flex justify-content-center">
      <div className="p-inputgroup flex-1">
        <AutoComplete
          ref={ac}
          value={selectedEntity}
          onChange={(e) => setSelectedEntity(e.value)}
          suggestions={filteredEntities}
          completeMethod={search}
          field="title"
          optionGroupLabel="label"
          optionGroupChildren="items"
          optionGroupTemplate={optionGroupTemplate}
          itemTemplate={groupedItemTemplate}
          placeholder="Търсене..."
          onSelect={onSelect}
          {...props}
        />
        {selectedEntity && <Button icon="pi pi-times" onClick={onClear} severity="secondary" />}
      </div>
    </div>
  );
}
